<template>
    <main class="contact">
        <div class="page-header">
            <h1 class="page-header__title">Wymagania sprzetowe</h1>
        </div>
    </main>
</template>

<script>
export default {
    name: "HardwareRequirements",
};

</script>

<style lang="scss">
</style>
